import { z } from 'zod';
import { isoDate } from './common.js';
export const ABSENCE_TYPES = ['sick', 'holiday'];
export const ABSENCE_TYPE_LABELS = {
    sick: 'Sick',
    holiday: 'Holiday',
};
export const createAbsenceSchema = z
    .object({
    workerId: z.string().uuid(),
    type: z.enum(ABSENCE_TYPES),
    startDate: isoDate,
    endDate: isoDate,
    notes: z.string().nullable().optional(),
})
    .refine((v) => v.endDate >= v.startDate, { message: 'End date must be on or after the start date', path: ['endDate'] });
export const absenceQuerySchema = z.object({
    workerId: z.string().uuid().optional(),
    from: isoDate.optional(),
    to: isoDate.optional(),
});
//# sourceMappingURL=absence.js.map